import * as Utils from '../utils/util';

interface PartitionMap {
    readonly roof: string,
    readonly beam: string,
    readonly layer: string,
    readonly dishrack: string,
    readonly cabinet: string
}
const partitionMap: PartitionMap = {
    roof: 'roof',
    beam: 'beam',
    layer: 'layer',
    dishrack: 'dishrack',
    cabinet: 'cabinet'
};

export function getCubeType(cube: CubeNode): CubeType|null {
    if (!cube) {
        return null;
    }

    if (cube.moduleName === 'sketchpad') {
        return 'sketchpad';
    }

    if (cube.moduleName === 'shelves') {
        return cube.cubeName === 'shelvesbuild-e-shelves-freezer' ? 'freezer' : 'shelf';
    }

    if (cube.moduleName === 'partition') {
        return partitionMap[cube.tplName];
    }

    if (cube.moduleName === 'goods') {
        if (Utils.getMapValueByStringKey(cube, 'goods[0].wareInfoVO.skuId') === -9998) {
            return 'bafflePlate';
        }

        if (Utils.getMapValueByStringKey(cube, 'goods[0].wareInfoVO.skuId') === -9999) {
            return 'textarea';
        }

        return 'goods';
    }

    return null;
}

export function getCubeDataType(cubeData: FreeObjMap): CubeDataType|null {
    if (!cubeData) {
        return null;
    }

    if (cubeData.moduleName === 'sketchpad') {
        return 'sketchpad';
    }

    if (cubeData.moduleName === 'shelves') {
        return cubeData.cubeName === 'shelvesbuild-e-shelves-freezer' ? 'freezer' : 'shelf';
    }

    if (cubeData.moduleName === 'partition') {
        return partitionMap[cubeData.tplName];
    }

    if (cubeData.moduleName === 'goods') {
        if (Utils.getMapValueByStringKey(cubeData, 'goods[0].wareInfoVO.skuId') === -9998) {
            return 'bafflePlate';
        }

        if (Utils.getMapValueByStringKey(cubeData, 'goods[0].wareInfoVO.skuId') === -9999) {
            return 'textarea';
        }

        return 'goods';
    }

    return null;
}

// 有无层板类型
export function hasPartition(types: Array<CubeType>): boolean {
    return types.includes('dishrack')
        || types.includes('beam')
        || types.includes('roof')
        || types.includes('layer')
        || types.includes('cabinet')
}
